module.exports = __webpack_public_path__ + "static/img/s97.9ecbf25f.png";